export const USER_GROUPS_LOAD = 'USER_GROUPS_LOAD';
export const USER_GROUPS_LOAD_SUCCESS = 'USER_GROUPS_LOAD_SUCCESS';
export const USER_GROUPS_LOAD_ERROR = 'USER_GROUPS_LOAD_ERROR';
export const USER_GROUPS_ADD = 'USER_GROUPS_ADD';
export const USER_GROUPS_ADD_SUCCESS = 'USER_GROUPS_ADD_SUCCESS';
export const USER_GROUPS_ADD_ERROR = 'USER_GROUPS_ADD_ERROR';
export const USER_GROUPS_UPDATE = 'USER_GROUPS_UPDATE';
export const USER_GROUPS_UPDATE_SUCCESS = 'USER_GROUPS_UPDATE_SUCCESS';
export const USER_GROUPS_UPDATE_ERROR = 'USER_GROUPS_UPDATE_ERROR';
export const USER_GROUPS_DELETE = 'USER_GROUPS_DELETE';
export const USER_GROUPS_DELETE_SUCCESS = 'USER_GROUPS_DELETE_SUCCESS';
export const USER_GROUPS_DELETE_ERROR = 'USER_GROUPS_DELETE_ERROR';
